export const businessInfo = {
  name: 'BKCustoms',
  legalName: 'BKCustoms Car Styling',
  street: 'Microfoonstraat 36',
  postalCode: '1322 BN',
  city: 'Almere',
  country: 'NL',
  phone: '+31627888306',
  phoneDisplay: '+31 (0)6 278 88 306',
  email: 'info@bkcustoms.nl',
  website: 'https://www.bkcustoms.nl',
  latitude: 52.375419,
  longitude: 5.221334,
  mapsUrl:
    'https://maps.google.com/?q=Microfoonstraat+36+1322+BN+Almere',
  reviewsUrl: 'https://www.google.com/search?q=Bk+Customs+Reviews',
} as const

/**
 * Opening hours — must stay identical to the Google Business Profile.
 * Google Business Profile: 7 days a week, 09:00 - 18:00.
 */
export const openingHours = {
  opens: '09:00',
  closes: '18:00',
  /** Short form used in the top bar and compact spots. */
  short: 'Ma-Zo: 09:00-18:00',
  /** Two-line form used in the footer and contact details. */
  lines: ['Maandag - Zondag', '09:00 - 18:00'],
  /** Full sentence form. */
  full: 'Elke dag open van 09:00 tot 18:00',
  /** schema.org days, all seven. */
  schemaDays: [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ],
} as const

/**
 * Google review data — the strongest conversion asset on the site.
 * Update both values together whenever the Google profile changes.
 */
export const googleReviews = {
  rating: 5.0,
  ratingDisplay: '5,0',
  count: 72,
} as const
